/**
 * Reusable stateless form component for Sponsor
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

// import form components
import { TextInput, UrlInput, SelectFromArray, NumberInput } from '../../../global/components/forms';

function SponsorForm({
  cancelLink
  , clearToken
  , formTitle
  , formType
  , generateToken
  , handleFormChange
  , handleFormSubmit
  , sponsor
  , showClearTokenModal
}) {

  // set the button text
  const buttonText = formType === "create" ? "Create Sponsor" : "Update Sponsor";

  // set the form header
  const header = formTitle ? <div className="formHeader"><h2> {formTitle} </h2><hr/></div> : <div/>;

  const types = ['pharma', 'acrp-subportal', 'partner', 'other']; 

  return (
    <div className="yt-container">
      <div className="yt-row center-horiz">
        <div className="form-container -slim">
          <form name="sponsorForm" className="sponsor-form" onSubmit={handleFormSubmit}>
            {header}
            <div className="yt-col full m_60">
              <TextInput
                change={handleFormChange}
                label="Name"
                name="name"
                placeholder="Name (required)"
                required={true}
                value={sponsor.name}
              />
              <UrlInput
                change={handleFormChange}
                label="Logo"
                name="logo"
                placeholder="Logo"
                required={false}
                value={sponsor.logo}
              />
              <SelectFromArray
                change={handleFormChange}
                display={'type'}
                label="Type"
                name="type"
                placeholder="-- Select a type --"
                items={['pharma','acrp-subportal','partner','other']}
                // required={true}
                value={sponsor.type}
              />
              <NumberInput
                change={handleFormChange}
                label="Order Weight"
                helpText="Order in which sponsors will display in agenda. 1 being the top, higher numbers being lower."
                name="orderWeight"
                step={1}
                value={sponsor.orderWeight}
              />
            </div>
            <div>
              <h4><strong>Auth Token</strong></h4>
              {sponsor.authToken ? 
                <div>
                  <p>This is for authenticating sponsors for third party invites. It must match the one sent from their site/team in order to work. If cleared this sponsor wont be authorized to invite users from their end.</p>
                  <p><strong>{sponsor.authToken}</strong></p>
                  <button className="yt-btn x-small danger" type="button" onClick={() => showClearTokenModal()}>Clear Token</button>
                </div>
              :
                <div>
                  <p><strong>No current auth token</strong></p>
                  <button className="yt-btn x-small" type="button" onClick={generateToken}>Generate Token</button>
                </div>
              }
            </div>
            <div style={{maxWidth: '200px'}}>
              {sponsor.logo ?
                <img src={sponsor.logo}/>
                :
                null 
              }
            </div>
            <div className="input-group">
              <div className="yt-row space-between">
                <Link className="yt-btn link" to={cancelLink}>Cancel</Link>
                <button className="yt-btn " type="submit" > {buttonText} </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

SponsorForm.propTypes = {
  cancelLink: PropTypes.string.isRequired
  , formTitle: PropTypes.string
  , formType: PropTypes.string.isRequired
  , handleFormChange: PropTypes.func.isRequired
  , handleFormSubmit: PropTypes.func.isRequired
  , sponsor: PropTypes.object.isRequired
}

SponsorForm.defaultProps = {
  formTitle: ''
}

export default SponsorForm;



// WEBPACK FOOTER //
// modules/sponsor/components/SponsorForm.js.jsx